<mat-expansion-panel
  [expanded]="expansionPanelExpanded"
  (expandedChange)="expansionPanelExpanded = $event"
  class="flotante-panel"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">crisis_alert</mat-icon>
      <span class="panel-title">Alertas</span>
      <span class="counter-badge">{{ formatCount(totalAlertas) }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="seccion">
    <div class="seccion-titulo">Capas</div>
    <div class="capas-grid">
      @for (capa of capas; track capa.key) {
        <button
          type="button"
          class="irx-chip irx-chip--multilinea capa-chip"
          [attr.aria-pressed]="tiposActivos.has(capa.key)"
          (click)="toggleTipo(capa.key)"
          [tooltip]="capa.label"
        >
          <mat-icon class="material-symbols-outlined">{{ capa.icon }}</mat-icon>
          <span class="capa-label">{{ capa.label }}</span>
          @if (capa.countGetter && capa.countGetter()) {
            <span class="capa-count">{{ formatCount(capa.countGetter()!) }}</span>
          }
        </button>
      }
    </div>
  </div>

  <div class="seccion">
    <div class="seccion-titulo">Alertas</div>
    <mat-slide-toggle
      class="solo-activas-toggle"
      [checked]="soloActivas"
      (change)="soloActivasChange.emit($event.checked)"
    >
      Solo activas
    </mat-slide-toggle>
  </div>

  <div class="seccion">
    <div class="seccion-titulo">Período</div>
    <mat-form-field appearance="outline" class="periodo-field">
      <mat-select
        [value]="filtroTemporal"
        (selectionChange)="onFiltroChange($event.value)"
      >
        @for (opt of opcionesTemporal; track opt.value) {
          <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (filtroTemporal === 'custom') {
      <div class="rango-custom">
        <app-date-picker
          mode="datetimerange"
          label="Rango"
          [(ngModel)]="rangoLocal"
        ></app-date-picker>
        @if (rangoError) {
          <div class="rango-error">{{ rangoError }}</div>
        }
        <button
          irxBoton="principal"
          (click)="aplicarRangoPersonalizado()"
        >
          Aplicar
        </button>
      </div>
    }
  </div>

  <div class="seccion">
    <div class="seccion-titulo">Búsqueda por polígono</div>
    <div class="poligono-acciones">
      @if (!dibujandoPoligono && !resumenPoligono) {
        <button
          irxBoton="secundario"
          tamano="compacto"
          bloque
          (click)="iniciarPoligono()"
        >
          <mat-icon class="material-symbols-outlined">draw</mat-icon>
          Dibujar polígono
        </button>
      }
      @if (dibujandoPoligono) {
        <button
          irxBoton="secundario"
          tamano="compacto"
          bloque
          (click)="cancelarPoligono()"
        >
          <mat-icon class="material-symbols-outlined">close</mat-icon>
          Cancelar dibujo
        </button>
      }
      @if (resumenPoligono) {
        <div class="poligono-resumen">
          <div class="resumen-item">
            <mat-icon class="material-symbols-outlined">crisis_alert</mat-icon>
            {{ resumenPoligono.alertas }} alertas
          </div>
          <div class="resumen-item">
            <mat-icon class="material-symbols-outlined">campaign</mat-icon>
            {{ resumenPoligono.sirenas }} sirenas
          </div>
          @if (resumenPoligono.vecinos != null) {
            <div class="resumen-item">
              <mat-icon class="material-symbols-outlined">person</mat-icon>
              {{ resumenPoligono.vecinos }} vecinos
            </div>
          }
          @if (resumenPoligono.controles != null) {
            <div class="resumen-item">
              <mat-icon class="material-symbols-outlined">verified</mat-icon>
              {{ resumenPoligono.controles }} controles
            </div>
          }
        </div>
        @if (
          resumenPoligono.truncados?.alertas ||
          resumenPoligono.truncados?.sirenas ||
          resumenPoligono.truncados?.vecinos
        ) {
          <div class="poligono-truncado">
            Resultados truncados — refiná la búsqueda
          </div>
        }
        <button
          irxBoton="principal"
          tamano="compacto"
          bloque
          [disabled]="exportandoPoligono"
          (click)="exportarPoligonoEvt.emit()"
        >
          <mat-icon class="material-symbols-outlined">download</mat-icon>
          {{ exportandoPoligono ? 'Exportando...' : 'Exportar XLSX' }}
        </button>
        <button
          irxBoton="secundario"
          tamano="compacto"
          bloque
          (click)="limpiarPoligono()"
        >
          <mat-icon class="material-symbols-outlined">clear</mat-icon>
          Limpiar
        </button>
      }
    </div>
  </div>

  @if (buscandoPoligono) {
    <mat-progress-bar
      mode="indeterminate"
      class="flotante-progress"
    ></mat-progress-bar>
  }
</mat-expansion-panel>
